import { Box, Typography } from '@mui/material';
import { getSegmentationJobDetails_getSEOSegmentationJobDetails_seoSegmentationJob_jobPreferences_HousekeepingJobPreferences as housekeepingJobPreferences } from '@/__generated__/getSegmentationJobDetails';

interface HousekeepingJobPreferencesProps {
  jobPreferences: housekeepingJobPreferences;
}

const HousekeepingJobPreferences = ({ jobPreferences }: HousekeepingJobPreferencesProps) => {
  return (
    <>
      {jobPreferences.homeSize && (
        <Box mt={2}>
          <Typography variant="body2">
            Home Size: {jobPreferences.homeSize.numberOfBedrooms}&nbsp;
            {jobPreferences.homeSize.numberOfBedrooms === 1 ? 'bedroom' : 'bedrooms'},&nbsp;
            {jobPreferences.homeSize.numberOfBathrooms}&nbsp;
            {jobPreferences.homeSize.numberOfBathrooms === 1 ? 'bathroom' : 'bathrooms'}
          </Typography>
        </Box>
      )}
      {jobPreferences.frequency && (
        <Box mt={2}>
          <Typography variant="body2">Frequency: {jobPreferences.frequency}</Typography>
        </Box>
      )}
      {jobPreferences.servicesNeeded && (
        <Box mt={2}>
          <Typography variant="body2">
            Services Needed: {jobPreferences.servicesNeeded.join(', ')}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default HousekeepingJobPreferences;
